import Grid from '@mui/material/Grid';
import TextInput from '../../components/TextInput';
import React from 'react';
import useConfigStyles from '../../components/useConfigStyles';
import { Variable } from '../../types/variable';

interface VariableDetailsProps {
  variable: Variable;
  errors?: Record<string, string[]>;
  editable: boolean;
  onVariableUpdate?: (variable: Variable, fieldName: string) => void;
}

function VariableDetails({ variable, errors, editable, onVariableUpdate }: VariableDetailsProps): JSX.Element {
  const classes = useConfigStyles();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onVariableUpdate) {
      return;
    }
    const { name, value } = event.target;
    onVariableUpdate(
      {
        ...variable,
        [name]: value,
      },
      name,
    );
  };

  return (
    <Grid container alignItems='center' justifyContent='center' spacing={2} className={classes.container}>
      <Grid item className={classes.input} md={10}>
        <TextInput name='Name' label='Name' value={variable.Name} onChange={handleInputChange} errors={errors} editable={editable} />
      </Grid>
      <Grid item className={classes.input} md={10}>
        <TextInput name='Description' label='Description' value={variable.Description} onChange={handleInputChange} errors={errors} editable={editable} />
      </Grid>
    </Grid>
  );
}

VariableDetails.defaultProps = {
  errors: {},
  onVariableUpdate: () => {},
};

export default VariableDetails;
